export default __webpack_public_path__ + "static/gd-3dc693efb98a7994f9b0965ebbbf387a.svg";